module.exports = __webpack_public_path__ + "media/images/cz1-60b09f4758b5bf854679fa9baa21a42c.svg";